import React from "react";
import DetailViewImportantBtn from "./DetailViewImportantBtn";
import DetailViewRatingBtn from "./DetailViewRatingBtn";
import DetailViewTagComponent from "./DetailViewTagComponent";
import { DetailViewComment } from "./DetailViewComment";
import DetailAgentEditWarning from "./DetailAgentEditWarning";

interface Props {
  important: boolean;
  selectedAgentResults: any;
  ratingValue: number | null;
  agentResult: any; // Backbone.Model
  context?: string; // 'agents' or 'newsroom'
}

export default function DetailViewFooter({
  important,
  selectedAgentResults,
  ratingValue,
  agentResult,
  context = 'agents',
}: Props) {
  const isAgentsModule = context === 'agents';

  return (
    <>
      <DetailAgentEditWarning agentResult={agentResult} />
      <div className="clip-actions">
        <div className={isAgentsModule ? "col2of5" : "col5of5"}>
          <DetailViewImportantBtn
            selectedAgentResults={selectedAgentResults}
            important={important}
          />
        </div>
        {isAgentsModule && (
          <div className="col3of5">
            <DetailViewRatingBtn
              selectedAgentResults={selectedAgentResults}
              ratingValue={ratingValue}
            />
          </div>
        )}
      </div>
      <div data-tags-partial>
        <DetailViewTagComponent
          selectedAgentResults={selectedAgentResults.collection}
        />
      </div>
      {isAgentsModule && (
        <>
          <hr className="separator-marginMedium" />
          <span data-comments-partial>
            <DetailViewComment agentResult={agentResult} />
          </span>
        </>
      )}
    </>
  );
}
